import { KModal } from '@/ui-library/components';
import { KText } from '@/ui-library/components';
import { SHARED_EMAIL_API_SERVICES } from '../api';
import { useMutation } from '@tanstack/react-query';
import { useShowToast } from '@/hooks';

const DeleteModal = ({ deleteModalActions, id, triggerRef, refetch }) => {
  const toast = useShowToast();
  const deleteDomain = useMutation({
    mutationFn: SHARED_EMAIL_API_SERVICES.deleteDomains,
    onSuccess: () => {
      toast({
        title: 'Domain deleted',
      });
      deleteModalActions?.onClose();
      refetch();
    },
  });

  const deleteEmail = useMutation({
    mutationFn: SHARED_EMAIL_API_SERVICES.deleteSharedEmail,
    onSuccess: () => {
      toast({
        title: 'Email deleted',
      });
      deleteModalActions?.onClose();
      refetch();
    },
  });

  const handleDeleteClickAction = () => {
    if (triggerRef === 'domain') {
      deleteDomain.mutate(id);
    } else {
      deleteEmail.mutate(id);
    }
    // refetch();
  };
  return (
    <KModal
      isOpen={deleteModalActions?.isOpen}
      onClose={deleteModalActions?.onClose}
      title={'Are you sure?'}
      modalContentProps={{ pt: '12px' }}
      modalBodyProps={{ pb: '32px', px: '24px' }}
      ctaLabel="Delete"
      ctaButtonProps={{
        variant: 'danger',
        isLoading: deleteDomain.isPending || deleteEmail.isPending,
      }}
      ctaAction={handleDeleteClickAction}
    >
      <KText>
        {triggerRef === 'domain'
          ? 'Deleting a domain is permanent. Any email addresses associated with the domain will also be deleted, and messages sent to those addresses will bounce.'
          : 'Deleting an email address is permanent. Messages sent to this email address will bounce.'}
      </KText>
    </KModal>
  );
};

export default DeleteModal;
